import React from 'react';
import NewsList from '../components/News/NewsList';
import NewsFilterBar, {useNewsFilters} from '../components/News/NewsFilterBar';
import {toApiFilters} from '../types/cardData';

const NewsPage: React.FC = () => {
    const {filters, setFilters} = useNewsFilters();
    const apiFilters = toApiFilters(filters);

    return (
        <div className="news-page" style={{ padding: '5px' }}>
            <NewsFilterBar filters={filters} onChange={setFilters} />
            <NewsList
                region={apiFilters?.region}
                relevance={apiFilters?.relevance}
            />
        </div>
    );
};

export default NewsPage;
